module.exports = __webpack_public_path__ + "static/media/dig-4.28c08353.png";